import { render, staticRenderFns } from "./SimpleTestimonial.vue?vue&type=template&id=301f22e6&scoped=true"
import script from "./SimpleTestimonial.vue?vue&type=script&lang=js"
export * from "./SimpleTestimonial.vue?vue&type=script&lang=js"
import style0 from "./SimpleTestimonial.vue?vue&type=style&index=0&id=301f22e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301f22e6",
  null
  
)

export default component.exports